import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'

//i18n
import { withTranslation } from 'react-i18next'

class ConfigurationContent extends Component {
	constructor(props) {
		super(props)
		this.refDiv = React.createRef()
	}

	render() {
		const { t } = this.props

		return (
			<React.Fragment>
				<li>
					<Link to="/#" className="has-arrow">
						<i className="bx bxs-cog"></i>
						<span>{t('configuration', { ns: 'naming' })}</span>
					</Link>
					<ul className="sub-menu" aria-expanded="false">
						<li>
							<Link to="/discount-voucher">
								{t('discountVoucher', { ns: 'naming' })}
							</Link>
						</li>
						<li>
							<Link to="/managers">
								{t('Managers', { ns: 'naming' })}
							</Link>
						</li>
						<li>
							<Link to="/holidays">{t('holidays', { ns: 'naming' })}</Link>
						</li>
						<li>
							<Link to="/carrier">{t('carrier', { ns: 'naming' })}</Link>
						</li>
						<li>
							<Link to="/supplier-list">
								{t('supplierList', { ns: 'naming' })}
							</Link>
						</li>
					</ul>
				</li>
			</React.Fragment>
		)
	}
}

ConfigurationContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
	type: PropTypes.string,
	initMenu: PropTypes.func,
}

export default withRouter(withTranslation()(ConfigurationContent))
